import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstpart'
})
export class FirstPartPipe implements PipeTransform {

  transform(value: string): string {
    const parts = value.split('/');
    return parts[0];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/first-part/first-part.pipe.ts